var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23.25C18.1675 23.25 23.25 18.1583 23.25 11.9941C23.25 5.84167 18.1557 0.75 12 0.75C5.83255 0.75 0.75 5.84167 0.75 11.9941C0.75 18.1583 5.84434 23.25 12 23.25ZM10.6629 17.75C10.3334 17.75 10.0863 17.6196 9.81564 17.2877L6.48536 13.222C6.34414 13.0323 6.25 12.8071 6.25 12.5819C6.25 12.1196 6.6148 11.7759 7.03844 11.7759C7.3091 11.7759 7.54446 11.8825 7.77981 12.1789L10.6158 15.7705L15.9702 7.20043C16.1585 6.90409 16.4174 6.75 16.6645 6.75C17.0881 6.75 17.5 7.03448 17.5 7.49677C17.5 7.66746 17.4247 7.85332 17.3283 8.01794L11.4631 17.2759C11.2513 17.5959 10.9806 17.75 10.6629 17.75Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCircleFilled);
export default __webpack_public_path__ + "static/media/success_circle_filled.0975b05ee29586b82d2b666c8dcb9ad7.svg";
export { ForwardRef as ReactComponent };